import React, { Component } from 'react'
import Collapsible from '../Collapsible'
import CheckBox from '../CheckBox'
import DropdownTreeSelect from "react-dropdown-tree-select"
import isEqual from 'lodash/isEqual'

class FilterTopics extends Component {
  constructor(props){
    super(props)
    this.state = { filterTopics: props.filterTopics, currentNode: 1, clearSearchOnChange: false }
  }

  componentWillReceiveProps = (nextProps) => {
    if(!isEqual(nextProps.filterTopics, this.state.filterTopics) || nextProps.selectedTopicIds.length <= 1 || this.state.currentNode == 0 ) {
      this.setState({ filterTopics: nextProps.filterTopics, currentNode: 1, clearSearchOnChange: nextProps.clearSearchOnChange })
    }
  }

  shouldComponentUpdate = (nextProps) => {
    return !isEqual(nextProps.filterTopics, this.state.filterTopics) || nextProps.selectedTopicIds.length <= 1 || this.state.currentNode == 0
  }

  topicChanged = (isChecked, selectedValue) => {
    this.setState({currentNode: selectedValue, clearSearchOnChange: true})    
    this.props.onChange({checked: isChecked, value: selectedValue}, [])
  }

  render () {
    const { filterTopics, selectedTopicIds, ...rest } = this.props
    
    const topics = (this.state.filterTopics
      .sort((a, b) => a.name != null && b.name != null && a.name.localeCompare(b.name)))
      .map(c => { return { value: c.id, label: c.name, checked: this.props.selectedTopicIds.includes(c.id) } })      

    return (
      (topics.length > 0) ?
      <Collapsible title='Topic' titleClassName='box-header' id='topic'>
          <div className='div-separator'>
            <CheckBox
              id='cbTopicAll'
              Name='cbTopicAll'
              Checked={this.props.selectedTopicIds.length === 0}
              onTickChanged={(chk, val) => this.topicChanged(chk, val)}
              Value='0' text='Show All'
            />
          </div>

          <DropdownTreeSelect id="Topics" name="topics" data={topics}
          showDropdown='always' disablePoppingOnBackspace={true} texts={{ placeholder: 'Search within Topics' }} {...rest} />
      </Collapsible>
      : null
    )
  }
}

export default FilterTopics
